/*
 * 08 PRO/AIR 移动切换。
 * 维护说明：仅同步当前型号状态与按钮 aria-pressed；卡片和参数列的显示由同 Section CSS 负责。
 * Theme Editor 重新载入 Section 时重新初始化，卸载时解除监听。
 */
(() => {
  if (window.BixdoGS2ModelSwitchLoaded) return;
  window.BixdoGS2ModelSwitchLoaded = true;

  const selector = '[data-gs2-model-switch]';

  function init(root) {
    if (root.gs2ModelSwitchCleanup) return;
    const buttons = Array.from(root.querySelectorAll('[data-gs2-model-button]'));
    if (buttons.length !== 2) return;

    const setModel = (model) => {
      if (model !== 'pro' && model !== 'air') return;
      root.dataset.gs2ActiveModel = model;
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.gs2ModelButton === model)));
    };
    const onClick = (event) => setModel(event.currentTarget.dataset.gs2ModelButton);
    const onKeydown = (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const currentIndex = Math.max(0, buttons.indexOf(event.currentTarget));
      let nextIndex = currentIndex;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = buttons.length - 1;
      const nextButton = buttons[nextIndex];
      setModel(nextButton.dataset.gs2ModelButton);
      nextButton.focus({ preventScroll: true });
    };
    buttons.forEach((button) => button.addEventListener('click', onClick));
    buttons.forEach((button) => button.addEventListener('keydown', onKeydown));
    setModel(root.dataset.gs2ActiveModel || 'pro');
    root.classList.add('is-enhanced');
    root.gs2ModelSwitchCleanup = () => {
      buttons.forEach((button) => button.removeEventListener('click', onClick));
      buttons.forEach((button) => button.removeEventListener('keydown', onKeydown));
      root.classList.remove('is-enhanced');
      delete root.gs2ModelSwitchCleanup;
    };
  }

  const initWithin = (scope) => {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll(selector).forEach(init);
  };
  const destroyWithin = (scope) => {
    if (scope.matches?.(selector)) scope.gs2ModelSwitchCleanup?.();
    scope.querySelectorAll(selector).forEach((root) => root.gs2ModelSwitchCleanup?.());
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initWithin(document));
  else initWithin(document);

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
})();
